import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
  padding: 0 0.4rem 0 0.4rem;
  width: 100%;
`

export const ContainerItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 1rem;
`

export const ContainerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 .4rem 0 .4rem;
  width: 100%;
  height: 2.5rem;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: .5rem;
`

export const CustomFieldMui = styled(TextFieldMui)`
`

export const ConfirmModalContainer = styled.span`
  display: grid;
`

export const ConfirmModalText = styled.label`
  font-size: 15px;
`

export const ConfirmModalConfirmationText = styled.label`
  font-size: 15px;
  font-weight: bold;
  text-align: end;
  margin-top: 10px !important;
`
